import { render, staticRenderFns } from "./TagInputs.vue?vue&type=template&id=41027979&scoped=true"
import script from "./TagInputs.vue?vue&type=script&lang=js"
export * from "./TagInputs.vue?vue&type=script&lang=js"
import style0 from "./TagInputs.vue?vue&type=style&index=0&id=41027979&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41027979",
  null
  
)

export default component.exports